module.exports = "<div class=\"offers-counter\">\n    <cian-ui-preloader\n            muted=\"true\"\n            size=\"16\"\n            ng-if=\"offersCounter.isUpdating()\"\n    ></cian-ui-preloader>\n\n    <ng-pluralize\n            count=\"offersCounter.count\"\n            when=\"::offersCounter.pluralForms\"\n    ></ng-pluralize>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/serp/directives/offers-counter/offers-counter.html
// module id = 1028
// module chunks = 0